export const SOURCE_PANEL_CLASS = 'meeting-source-panel';
export const SOURCE_PANEL_SLIDE_MS = 300;
